<template>
  <div class="app-page box-card">
    <div class="box-card-content">
      <div class="reset-query query">
        <el-form :inline="true" :model="queryForm">
          <el-form-item label="姓名/用户ID">
            <template slot="label">
              <I18Lang id="proxycust4" defaultText="姓名/用户ID/交易账号" />
            </template>
            <el-input
              v-model="queryForm.username"
              :placeholder="$t('proxycust128')"
            ></el-input>
          </el-form-item>

          <div class="btn kg-btn2" @click="queryChange">
            <I18Lang id="my85" defaultText="查询" />
          </div>
          <div
            class="btn kg-refresh btn-query-refresh"
            @click="resetChange"
          ></div>
          <div class="btn kg-btn2" @click="importData">
            <I18Lang id="my137" defaultText="导出" />
          </div>
        </el-form>
      </div>

      <div class="reset-table table" v-loading="isTableLoading">
        <el-table :data="tableData.list" style="width: 100%">
          <el-table-column width="180" label="姓名">
            <template slot="header">
              <I18Lang id="index21" defaultText="姓名" />
            </template>
            <template slot-scope="{ row }">
              {{ row.user ? row.user.username : "" }}
            </template>
          </el-table-column>
          <el-table-column width="150" label="用户ID" prop="account_id">
            <template slot="header">
              <I18Lang id="proxymoney89" defaultText="用户ID" />
            </template>
            <template slot-scope="{ row }">
              {{ row.user ? row.user.account_id : "" }}
            </template>
          </el-table-column>

          <el-table-column width="150" label="交易账号" prop="account_id">
            <template slot="header">
              <I18Lang id="proxycust26" defaultText="交易账号" />
            </template>
            <template slot-scope="{ row }">
              {{ row.user ? row.user.account_no : "" }}
            </template>
          </el-table-column>

          <el-table-column width="150" label="上级代理" prop="username">
            <template slot="header">
              <I18Lang id="text51" defaultText="上级代理" />
            </template>
            <template slot-scope="{ row }">
              {{ row.agent3user ? row.agent3user.username : "" }}
            </template>
          </el-table-column>

          <el-table-column width="180" label="当前存储空间价值" prop="fixed_value">
            <template slot="header">
              <I18Lang id="text81" defaultText="当前存储空间价值" />
            </template>
          </el-table-column>

          <el-table-column width="180" label="累计每日成长赠金（MEQ-P）" prop="total_opx_s">
            <template slot="header">
              <I18Lang id="text183" defaultText="累计每日成长赠金（MEQ-P）" />
            </template>
          </el-table-column>

          <el-table-column width="180" label="剩余每日成长赠金（MEQ-P）" prop="opx_s">
            <template slot="header">
              <I18Lang id="text82" defaultText="剩余每日成长赠金（MEQ-P）" />
            </template>
          </el-table-column>

          <el-table-column width="180" label="累计获得元股（MEQ）" prop="total_opx">
            <template slot="header">
              <I18Lang id="text84" defaultText="累计获得元股（MEQ）" />
            </template>
          </el-table-column>

          <el-table-column width="180" label="已激活风险补偿赠金（MEQ-A）" prop="opx_t">
            <template slot="header">
              <I18Lang id="text185" defaultText="已激活风险补偿赠金（MEQ-A）" />
            </template>
          </el-table-column>

        </el-table>
        <div class="page">
          <el-pagination
            background
            :page-size="queryForm.size"
            @current-change="pageChange"
            layout="prev, pager, next"
            :total="tableData.total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formateObjToParamStr, serverUrl } from '@utils'
import { mapState } from 'vuex'
import cookie from '@utils/cookie'
export default {
  name: 'record',
  data () {
    return {
      serverUrl,
      queryForm: {
        username: '',
        page: 1,
        size: 15
      },
      writeType: '',
      currentData: {},
      isTableLoading: false,
      tableData: {
        list: [],
        total: 0
      }
    }
  },
  created () {
    this.getRecord()
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    importData () {
      const params = {
        token: cookie.get('kg-client-token'),
        ...this.queryForm,
        is_export: 1
      }
      window.open(
        `/api/agent/opxUsers?${formateObjToParamStr(params)}`
      )
    },
    getRecord () {
      this.isTableLoading = true
      this.$http
        .post('/api/agent/opxUsers', this.queryForm)
        .then((result) => {
          console.log('result', result)
          this.tableData = result
        })
        .finally(() => {
          this.isTableLoading = false
        })
    },
    queryChange () {
      this.pageChange(1)
    },
    resetChange () {
      Object.keys(this.queryForm).map((item) => {
        if (!['page', 'size', 'is_agent'].includes(item)) {
          this.queryForm[item] = ''
        }
      })
      this.queryChange()
    },
    pageChange (page) {
      this.queryForm.page = page
      this.getRecord()
    }
  }
}
</script>
<style scoped lang="scss">
.page-main {
  .box-card-header {
    padding-bottom: 10px;

    .right {
      .statistics {
        font-size: 16px;
        color: #2a2a2a;
        letter-spacing: 0;
        line-height: 32px;
        vertical-align: top;
        margin-top: 5px;

        .num {
          color: #e61816;
        }
      }
    }
  }

  .box-card-content {
    .query {
      display: flex;
      justify-content: space-between;

      .btn-red {
        background: #e61816;
        border-color: #e61816;
      }
    }

    .table {
      ::v-deep .el-table {
        thead {
          tr,
          th {
            background: #f4f4f4;
            text-align: center;
          }
        }

        td {
          font-size: 14px;
          padding: 16px 0;
          text-align: center;
        }
      }

      .page {
        padding-top: 24px;
        text-align: right;

        ::v-deep .el-pager {
          .active {
            background: #e61816;
          }
        }
      }
    }
  }
}

.bank-info {
  p {
    margin-bottom: 10px;
  }
}

.operat-group {
  .operat-item {
    display: inline-block;
    margin-right: 15px;
    font-size: 14px;
    color: #0f75bd;
    letter-spacing: 0;
    text-align: center;
    line-height: 24px;
    text-decoration: underline;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
